import React, { ReactElement, useState } from "react";
import { GoPlus } from "react-icons/go";
import { FiMinus } from "react-icons/fi";
import { Link } from "react-router-dom";

interface IExpandableMenuItem {
  icon?: ReactElement;
  menu: {
    title: string;
    subMenus: {
      title: string;
      path: string;
    }[];
  };
}

export const ExpandableMenuItem: React.FC<IExpandableMenuItem> = (props) => {
  const { icon, menu } = props;

  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <>
      <div className="ml-3 p-1 expandable-menu-item">
        <div className="menu-item" onClick={() => setExpanded(!expanded)}>
          {icon}
          <div className="menu-item menu-item-title">{menu.title}</div>
          {expanded ? <FiMinus /> : <GoPlus />}
        </div>
        {expanded && (
          <>
            {menu.subMenus.map((subMenu) => (
              <Link
                key={subMenu.title + "key"}
                className="text-white menu-item sub-menu-item"
                to={subMenu.path}
              >
                {subMenu.title}
              </Link>
            ))}
          </>
        )}
      </div>
    </>
  );
};
